/*! @pentacode/ui v0.1.0 */
import { b as e, d as t, f as n, g as r, l as i, m as a, p as o, v as s, x as c } from "./guide-layout-CrWsmVuf.js";
import { b as l, v as u } from "./shared-D0HMDGlg.js";
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/none.js
function d(e, t) {
	if ((o = e.length) > 1) for (var n = 1, r, i, a = e[t[0]], o, s = a.length; n < o; ++n) for (i = a, a = e[t[n]], r = 0; r < s; ++r) a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/none.js
function f(e) {
	for (var t = e.length, n = Array(t); --t >= 0;) n[t] = t;
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/stack.js
function p(e, t) {
	return e[t];
}
function m(e) {
	let t = [];
	return t.key = e, t;
}
function h() {
	var e = l([]), t = f, n = d, r = p;
	function i(i) {
		var a = Array.from(e.apply(this, arguments), m), o, s = a.length, c = -1, l;
		for (let e of i) for (o = 0, ++c; o < s; ++o) (a[o][c] = [0, +r(e, a[o].key, c, i)]).data = e;
		for (o = 0, l = u(t(a)); o < s; ++o) a[l[o]].index = o;
		return n(a, l), a;
	}
	return i.keys = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : l(Array.from(t)), i) : e;
	}, i.value = function(e) {
		return arguments.length ? (r = typeof e == "function" ? e : l(+e), i) : r;
	}, i.order = function(e) {
		return arguments.length ? (t = e == null ? f : typeof e == "function" ? e : l(Array.from(e)), i) : t;
	}, i.offset = function(e) {
		return arguments.length ? (n = e ?? d, i) : n;
	}, i;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/expand.js
function g(e, t) {
	if ((r = e.length) > 0) {
		for (var n, r, i = 0, a = e[0].length, o; i < a; ++i) {
			for (o = n = 0; n < r; ++n) o += e[n][i][1] || 0;
			if (o) for (n = 0; n < r; ++n) e[n][i][1] /= o;
		}
		d(e, t);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/silhouette.js
function _(e, t) {
	if ((i = e.length) > 0) {
		for (var n = 0, r = e[t[0]], i, a = r.length; n < a; ++n) {
			for (var o = 0, s = 0; o < i; ++o) s += e[o][n][1] || 0;
			r[n][1] += r[n][0] = -s / 2;
		}
		d(e, t);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/wiggle.js
function v(e, t) {
	if ((o = e.length) > 0 && (a = (i = e[t[0]]).length) > 0) {
		for (var n = 0, r = 1, i, a, o; r < a; ++r) {
			for (var s = 0, c = 0, l = 0; s < o; ++s) {
				for (var u = e[t[s]], f = u[r][1] || 0, p = (f - (u[r - 1][1] || 0)) / 2, m = 0; m < s; ++m) {
					var h = e[t[m]], g = h[r][1] || 0, _ = h[r - 1][1] || 0;
					p += g - _;
				}
				c += f, l += p * f;
			}
			i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
		}
		i[r - 1][1] += i[r - 1][0] = n, d(e, t);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/appearance.js
function y(e) {
	var t = e.map(b);
	return f(e).sort(function(e, n) {
		return t[e] - t[n];
	});
}
function b(e) {
	for (var t = -1, n = 0, r = e.length, i, a = -Infinity; ++t < r;) (i = +e[t][1]) > a && (a = i, n = t);
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/ascending.js
function x(e) {
	for (var t = 0, n = -1, r = e.length, i; ++n < r;) (i = +e[n][1]) && (t += i);
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/insideOut.js
function S(e) {
	var t = e.length, n, r, i = e.map(x), a = y(e), o = 0, s = 0, c = [], l = [];
	for (n = 0; n < t; ++n) r = a[n], o < s ? (o += i[r], c.push(r)) : (s += i[r], l.push(r));
	return l.reverse().concat(c);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/stack-internal.js
function C(e, t = {}) {
	let n = T(t);
	if (e.length === 0) return /* @__PURE__ */ new Map();
	let r = [], i = /* @__PURE__ */ new Map(), a = [], o = /* @__PURE__ */ new Set();
	for (let t of e) {
		let e = c(t.position);
		i.has(e) || (i.set(e, r.length), r.push(t.position));
		let n = c(t.series);
		o.has(n) || (o.add(n), a.push(t.series));
	}
	let s = r.map(() => /* @__PURE__ */ Object.create(null)), l = /* @__PURE__ */ new Map();
	for (let t of e) {
		let e = i.get(c(t.position)), n = c(t.series), r = `${e}:${n}`;
		if (l.has(r)) throw TypeError(`A stack requires at most one value for each position and series; duplicate ${String(t.position)} / ${String(t.series)}`);
		l.set(r, t.index), s[e][n] = t.value;
	}
	let u = t.order === "inside-out";
	if (n !== void 0 && e.some(({ value: e }) => e < 0)) throw TypeError("A stack anchor requires nonnegative values");
	let f = M(e, a, t.order);
	t.reverse && !u && f.reverse();
	let p = f.map(c), m = t.anchor ? d : t.offset === "normalize" ? g : t.offset === "center" ? _ : t.offset === "wiggle" ? v : w, y = h().keys(p).value((e, t) => e[t] ?? 0).offset(m);
	u && y.order(t.reverse ? (e) => S(e).reverse() : S);
	let b = y(s);
	t.anchor && n !== void 0 && E(b, t.anchor.series, n), t.offset === "wiggle" && D(b);
	let x = /* @__PURE__ */ new Map();
	return b.forEach((e) => {
		let t = e.key;
		e.forEach((e, n) => {
			let r = l.get(`${n}:${t}`);
			r !== void 0 && x.set(r, {
				start: e[0],
				end: e[1]
			});
		});
	}), x;
}
function w(e, t) {
	if (e.length === 0) return;
	let n = e.map((e) => {
		let t = !1, n = !1;
		for (let [r, i] of e) {
			let e = i - r;
			e < 0 ? t = !0 : e > 0 && (n = !0);
		}
		return t && !n;
	}), r = e[t[0]].length;
	for (let i = 0; i < r; i += 1) {
		let r = 0, a = 0;
		for (let o of t) {
			let t = e[o][i], s = t[1] - t[0];
			s > 0 ? (t[0] = r, t[1] = r += s) : s < 0 ? (t[1] = a, t[0] = a += s) : s === 0 ? t[0] = t[1] = n[o] ? a : r : (t[0] = 0, t[1] = s);
		}
	}
}
function T(e) {
	let t = e.anchor;
	if (!t) return;
	if (e.offset !== void 0 && e.offset !== "diverging") throw TypeError("A stack anchor can only be used with the diverging offset");
	let n = t.fraction ?? .5;
	if (!Number.isFinite(n) || n < 0 || n > 1) throw TypeError("A stack anchor fraction must be between zero and one");
	return n;
}
function E(e, t, n) {
	let r = c(t), i = e.find((e) => e.key === r);
	if (!i) throw TypeError(`Stack anchor series "${String(t)}" is not in the resolved series order`);
	i.forEach((t, r) => {
		let i = t[0] + (t[1] - t[0]) * n;
		for (let t of e) {
			let e = t[r];
			e && (e[0] -= i, e[1] -= i);
		}
	});
}
function D(e) {
	let t = Infinity;
	for (let n of e) for (let e of n) t = Math.min(t, e[0]);
	if (Number.isFinite(t) && t !== 0) for (let n of e) for (let e of n) e[0] -= t, e[1] -= t;
}
function O(e, t, n, r = {}, i = "value") {
	let a = [];
	for (let r = 0; r < e.length; r += 1) {
		let o = e[r], s = t[r];
		if (!A(o) || !j(s)) continue;
		let c = n[r];
		a.push({
			index: r,
			position: o,
			value: s,
			series: k(c) ? c : i === "index" ? r : "value"
		});
	}
	let o = C(a, r), s = Array.from({ length: e.length }, () => void 0), c = Array.from({ length: e.length }, () => void 0);
	for (let [e, t] of o) s[e] = t.start, c[e] = t.end;
	return {
		starts: s,
		ends: c
	};
}
function k(e) {
	return typeof e == "string" || typeof e == "number";
}
function A(e) {
	return typeof e == "string" || j(e) || e instanceof Date && Number.isFinite(e.getTime());
}
function j(e) {
	return typeof e == "number" && Number.isFinite(e);
}
function M(e, t, n) {
	if (Array.isArray(n)) {
		let e = [...n], r = new Set(e.map(c));
		return [...e, ...t.filter((e) => !r.has(c(e)))];
	}
	if (n !== "ascending" && n !== "descending") return [...t];
	let r = new Map(t.map((e) => [c(e), 0]));
	for (let t of e) {
		let e = c(t.series);
		r.set(e, (r.get(e) ?? 0) + Math.abs(t.value));
	}
	return [...t].sort((e, t) => {
		let i = (r.get(c(e)) ?? 0) - (r.get(c(t)) ?? 0);
		return n === "ascending" ? i : -i;
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/line.js
function N(e, t = {}) {
	let n = Array.isArray(e) ? e : Array.from(e);
	return P(n, t, "line", () => {
		let e = i(n, t.x, (e, { index: t }) => t);
		return {
			xValues: e,
			yValues: i(n, t.y, (e) => typeof e == "number" ? e : void 0),
			isValidX: o,
			isValidY: a,
			keyValues: e,
			affinity: "x"
		};
	});
}
function P(a, o, l, u) {
	let d = o.xScale ?? "x", f = o.yScale ?? "y";
	return t(({ markIndex: t }) => {
		let p = o.id ?? `${l}-${t}`, { xValues: m, yValues: h, isValidX: g, isValidY: _, keyValues: v, affinity: y } = u(), b = i(a, o.z, () => null), x = o.color === void 0 ? b : i(a, o.color, () => null), S = o.z === void 0 && o.color !== void 0 ? x : b, C = n(a, o.key, {
			groups: S,
			candidates: [v],
			markId: p,
			warningIdentity: o
		}), w = a.map((e, t) => ({
			datum: e,
			datumIndex: t,
			xValue: m[t],
			yValue: h[t],
			groupValue: S[t],
			datumKey: C[t]
		}));
		return {
			id: p,
			states: r(a, o.states),
			seriesFromColor: o.z === void 0 && o.color !== void 0,
			channels: {
				x: {
					scale: d,
					values: m.filter(g)
				},
				y: {
					scale: f,
					values: h.filter(_)
				},
				color: {
					scale: "color",
					values: x.filter(e)
				}
			},
			render: ({ scales: e, color: t }) => {
				let n = F(w), r = [];
				for (let [i, l] of n) {
					let n = l[0];
					if (!n) continue;
					let u = s(o.stroke, n.datum, n.datumIndex, a, t(x[n.datumIndex] ?? null)), m = [], h = [], v = [], b = 0, S = () => {
						h.length && (m.push({
							kind: "polyline",
							key: `${p}:${i}:segment:${b}`,
							points: h,
							path: o.curve?.line(h),
							interaction: {
								points: v,
								affinity: y
							},
							style: {
								fill: "none",
								stroke: u,
								strokeOpacity: o.strokeOpacity,
								strokeWidth: o.strokeWidth ?? 2.25,
								strokeDasharray: o.strokeDasharray,
								lineCap: o.lineCap || "round",
								lineJoin: o.lineJoin || "round"
							}
						}), h = [], v = [], b += 1);
					};
					for (let t of l) {
						if (!g(t.xValue) || !_(t.yValue)) {
							S();
							continue;
						}
						let n = e[d].map(t.xValue), r = e[f].map(t.yValue), a = {
							key: `${p}:${i}:${c(t.datumKey)}`,
							markId: p,
							group: t.groupValue ?? null,
							groupLabel: t.groupValue == null ? p : String(t.groupValue),
							datum: t.datum,
							datumIndex: t.datumIndex,
							xValue: t.xValue,
							yValue: t.yValue,
							x: n,
							y: r,
							color: u
						};
						v.push(a), h.push([n, r]), o.points && m.push({
							kind: "dot",
							key: `${a.key}:dot`,
							x: n,
							y: r,
							radius: 2.5,
							pointOwner: a,
							style: { fill: u }
						});
					}
					S(), r.push({
						kind: "group",
						key: `${p}:${i}`,
						className: "ts-chart__line",
						ariaHidden: !0,
						children: m
					});
				}
				return { nodes: r };
			}
		};
	}, o.motion, o.renderer);
}
function F(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = c(n.groupValue ?? null), r = t.get(e);
		r ? r.push(n) : t.set(e, [n]);
	}
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/rule.js
function I(n, r = {}) {
	let a = Array.isArray(n) ? n : Array.from(n), l = r.yScale ?? "y";
	return t(({ markIndex: t }) => {
		let n = r.id ?? `rule-y-${t}`, u = i(a, r.y, (e) => o(e) ? e : void 0), d = i(a, r.color, () => null);
		return {
			id: n,
			channels: {
				y: {
					scale: l,
					values: u.filter(o)
				},
				color: {
					scale: "color",
					values: d.filter(e)
				}
			},
			render: ({ scales: t, chart: i, theme: f, color: p }) => {
				let m = [], h = [];
				return a.forEach((g, _) => {
					let v = u[_];
					if (!o(v)) return;
					let y = `${n}:${c(v)}:${_}`;
					m.push({
						kind: "rule",
						key: y,
						x1: i.x,
						x2: i.x + i.width,
						y1: t[l].map(v),
						y2: t[l].map(v),
						style: {
							stroke: s(r.stroke, g, _, a, d[_] == null ? f.foreground : p(d[_])),
							strokeOpacity: r.strokeOpacity ?? .5,
							strokeWidth: r.strokeWidth,
							strokeDasharray: r.strokeDasharray
						}
					}), h.push({
						key: y,
						markId: n,
						group: e(d[_]) ? d[_] : null,
						datum: g,
						datumIndex: _,
						yValue: v
					});
				}), {
					nodes: [{
						kind: "group",
						key: n,
						className: "ts-chart__rule ts-chart__rule-y",
						ariaHidden: !0,
						children: m
					}],
					focusAnchors: h
				};
			}
		};
	}, r.motion, r.renderer);
}
function L(n, r = {}) {
	let a = Array.isArray(n) ? n : Array.from(n), l = r.xScale ?? "x";
	return t(({ markIndex: t }) => {
		let n = r.id ?? `rule-x-${t}`, u = i(a, r.x, (e) => o(e) ? e : void 0), d = i(a, r.color, () => null);
		return {
			id: n,
			channels: {
				x: {
					scale: l,
					values: u.filter(o)
				},
				color: {
					scale: "color",
					values: d.filter(e)
				}
			},
			render: ({ scales: t, chart: i, theme: f, color: p }) => {
				let m = [], h = [];
				return a.forEach((g, _) => {
					let v = u[_];
					if (!o(v)) return;
					let y = `${n}:${c(v)}:${_}`;
					m.push({
						kind: "rule",
						key: y,
						x1: t[l].map(v),
						x2: t[l].map(v),
						y1: i.y,
						y2: i.y + i.height,
						style: {
							stroke: s(r.stroke, g, _, a, d[_] == null ? f.foreground : p(d[_])),
							strokeOpacity: r.strokeOpacity ?? .5,
							strokeWidth: r.strokeWidth,
							strokeDasharray: r.strokeDasharray
						}
					}), h.push({
						key: y,
						markId: n,
						group: e(d[_]) ? d[_] : null,
						datum: g,
						datumIndex: _,
						xValue: v
					});
				}), {
					nodes: [{
						kind: "group",
						key: n,
						className: "ts-chart__rule ts-chart__rule-x",
						ariaHidden: !0,
						children: m
					}],
					focusAnchors: h
				};
			}
		};
	}, r.motion, r.renderer);
}
//#endregion
export { S as a, O as i, I as n, N as r, L as t };

//# sourceMappingURL=rule-D2ufK5oT.js.map